import { createSelector } from '@ngrx/store';
import {
  getFeatureToggleState,
  getGiftingState,
  getMXMState,
  getTriageState,
} from '@store/reducers';
import { FeatureToggleState } from '@store/reducers/feature/feature.reducer';
import { GiftingState } from '@store/reducers/gifting/gifting.reducer';
import { MXMState } from '@store/reducers/mxm/mxm.reducer';
import { TriageState } from '@store/reducers/triage/triage.reducer';

import { nullState } from '../common/router.selectors';
import {
  getGiftingAssetsNextPage,
  getGiftingMethodNextPage,
  getGiftingOverviewNextPage,
  getGiftingRecipientNextPage,
  getGiftingRecipientTriageNextPage,
  getGiftingReviewNextPage,
  getGiftingTermsNextPage,
  getGiftingTriageNextPage,
} from './gifting-router.helpers';

export const selectGiftingOverviewNextPage = createSelector(nullState, () =>
  getGiftingOverviewNextPage(),
);
export const selectGiftingTriageNextPage = createSelector(nullState, () =>
  getGiftingTriageNextPage(),
);
export const selectGiftingAssetsNextPage = createSelector(nullState, () =>
  getGiftingAssetsNextPage(),
);
export const selectGiftingRecipientNextPage = createSelector(nullState, () =>
  getGiftingRecipientNextPage(),
);

export const selectGiftingReviewNextPage = createSelector(
  getMXMState,
  getFeatureToggleState,
  (mxmState: MXMState, featureToggleState: FeatureToggleState) =>
    getGiftingReviewNextPage(mxmState, featureToggleState),
);

export const selectGiftingTermsNextPage = createSelector(
  getMXMState,
  getFeatureToggleState,
  (mxmState: MXMState, featureToggleState: FeatureToggleState) =>
    getGiftingTermsNextPage(mxmState, featureToggleState),
);
export const selectGiftingRecipientTriageNextPage = createSelector(nullState, () =>
  getGiftingRecipientTriageNextPage(),
);
export const selectGiftingMethodNextPage = createSelector(nullState, () =>
  getGiftingMethodNextPage(),
);
